import React, {useState} from "react";
import {Popover, Collapse, Tabs, Spin} from "antd";
import CustomLoadFooter from "../customEmpty/CustomLoadFooter";
import {request} from "../../util/request";
import {GLOBAL_PERSONAL_CENTER_API} from "../../config/api";
import {ObjTest} from "jzfz-web-utils";
import InfiniteScroll from 'react-infinite-scroller';
import {
    CaretDownOutlined,
    CaretUpOutlined,
} from '@ant-design/icons';
import './style/viewHistoryPopover.less';


const { Panel } = Collapse;
const { TabPane } = Tabs;


interface ViewHistoryPopoverProps {
    pkid: string;   // 知识pkid
    moduleType: number;   // 模块类型
    children: React.ReactNode;
}


/**
 * 浏览记录
 * @constructor
 */
const ViewHistoryPopover = (props: ViewHistoryPopoverProps) => {
    const {
        pkid,
        moduleType,
        children,
    } = props;
    const [dataSource, setDataSource] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const [groupDataSource, setGroupDataSource] = useState<any[]>([]);  // 分组数据源
    const [groupLoading, setGroupLoading] = useState<boolean>(false);
    const [activeKey, setActiveKey] = useState<string>('1');


    /**
     * 获取浏览记录
     */
    const getViewHistory = (page: number = 1, firstLoad?: boolean) => {
        setLoading(true);
        request('/view-knowledge/viewPerson', {page, pageSize: 20, appType: moduleType, knowledgePkId: pkid}, {baseURL: GLOBAL_PERSONAL_CENTER_API})
        .then((res: any) => {
            if (!ObjTest.isNotEmptyArray(res.data)) {
                setHasMore(false);
                return;
            }
            if (firstLoad) {
                setHasMore(true);
                setDataSource(res.data);
                return;
            }
            setDataSource((v: any) => [...v, ...res.data]);
        }).finally(() => {
            setLoading(false);
        })
    }


    /**
     * 获取分组浏览记录
     */
    const getGroupData = () => {
        setGroupLoading(true);
        request('/view-knowledge/companyViewPerson', {appType: moduleType, knowledgePkId: pkid}, {baseURL: GLOBAL_PERSONAL_CENTER_API})
        .then((res: any) => {
            setGroupDataSource(res.data);
        }).finally(() => {
            setGroupLoading(false);
        })
    }


    /**
     * 获取浏览记录行
     * @param v
     * @param i
     */
    const getRow = (v: any, i: number): React.ReactNode => (
        <li key={i}>
            <span className="user-text eps" title={`${v.userName}（${v.user}）`}>{v.userName}</span>
            <span className="company-text eps" title={`${v.companyName}/${v.deptName}`}>{v.companyName}/{v.deptName}</span>
            <span className="time-text eps">{v.time}</span>
        </li>
    )


    /**
     * 点击tab
     * @param key
     */
    const tabClickHandle = (key: string) => {
        if (ObjTest.isNotEmptyArray(groupDataSource)) {
            return;
        }
        if (key === '2') {
            getGroupData();
        }
    }


    /**
     * 获取浏览记录
     */
    const getViewPopover = () => {
        return (
            <div style={{minHeight: 300}} onClick={(e: any) => e.stopPropagation()}>
                <Tabs
                    activeKey={activeKey}
                    onChange={(key: string) => setActiveKey(key)}
                    onTabClick={tabClickHandle}>
                    <TabPane className="history-list history-all-list" key="1" tab="全部">
                        <InfiniteScroll
                            pageStart={1}
                            initialLoad={false}
                            loadMore={getViewHistory}
                            hasMore={!loading && hasMore}
                            useWindow={false}
                        >
                            <div>
                                <ul>{
                                        dataSource.map((v: any, i: number) => getRow(v, i))
                                    }
                                </ul>
                                <CustomLoadFooter
                                    emptyText="暂无更多浏览记录"
                                    dataSource={dataSource}
                                    loading={loading}
                                    hasMore={hasMore}
                                />
                            </div>
                        </InfiniteScroll>
                    </TabPane>
                    <TabPane className="history-list" key="2" tab="按公司">
                        <Spin spinning={groupLoading}>
                            <Collapse
                                ghost
                                expandIcon={(panelProps: any) => {
                                    const { isActive } = panelProps;
                                    return isActive ? <CaretUpOutlined /> : <CaretDownOutlined />
                                }}
                            >
                                {
                                    groupDataSource.map((v: any, i: number) => (
                                        <Panel
                                            header={
                                                <span className="eps1" title={`${v.companyName}（${v.viewPersonCount}）`}>{v.companyName}（{v.viewPersonCount}）</span>
                                            }
                                            key={i}
                                        >
                                            <ul>
                                                {
                                                    (v.viewPersons || []).map((item: any, j: number) => getRow(item, j))
                                                }
                                            </ul>
                                        </Panel>
                                    ))
                                }
                            </Collapse>
                        </Spin>
                    </TabPane>
                </Tabs>
            </div>
        )
    }


    return (
        <Popover
            overlayClassName="view-history-popover-wrap"
            trigger={['click']}
            content={getViewPopover}
            destroyTooltipOnHide={true}
            arrowPointAtCenter={true}
            onVisibleChange={(visible: boolean) => {
                if (visible) {
                    setActiveKey('1');
                    setGroupDataSource([]);
                    getViewHistory(1, true);
                }
            }}
        >{children}
        </Popover>
    )
}


export default ViewHistoryPopover;
